import 'core-js/stable'
import 'regenerator-runtime/runtime'

import Vue from 'vue'
import VueMeta from 'vue-meta'
import App from './App.vue'
import router from './router'
import store from './store'
import { inithandler } from "@/bridge/jsBridge";
import { showToast, getStatusBarHeight } from "@/bridge/AppJsBridge";
import { Toast, Dialog } from "vant";
import { cdnLink } from "@/config";
import { isAndroid } from '@/libs/utils.js';
import { setStorage, getStorage } from '@/libs/utils';
import { customDialog } from '@/libs/utils.js';
import Sentry from '@/libs/sentry'

import '@/assets/rem/rem'
import './assets/css/index.scss';

// import eruda from 'eruda';
// eruda.init();
// if (process.env.NODE_ENV === 'development') {
// }


Vue.use(Toast);
Vue.use(Dialog );

Vue.config.productionTip = false;
Vue.config.devtools = false;

Vue.prototype.$cdnLink = cdnLink;
Vue.prototype.$setStorage = setStorage;
Vue.prototype.$getStorage = getStorage;
if (isAndroid()) {
  inithandler();
}
Vue.use(VueMeta);
console.log(store)
new Vue({
  router,
  store,
  mounted() {
    window.showToast = showToast;
    window.getStatusBarHeight = getStatusBarHeight;
    window.customDialog = customDialog;
    window.store = store;
  },
  render: h => h(App)
}).$mount('#app')

if (process.env.NODE_ENV !== 'development') {
  new Sentry();
}
